/**
 * The public demo's own Firebase identity (exception M1): a project that exists nowhere and hosts under `.invalid`
 * (a name DNS never resolves), so even a call the demo's guards missed could not reach Prest0's project, and the Auth
 * SDK's stored user lives under a key no real session uses. On the first download: src/utils/firebase.ts chooses it.
 */
import type { DemoIndustryId } from './demoIndustries';

export const DEMO_PROJECT_ID = 'demo-prest0';

export function demoFirebaseConfig(industry: DemoIndustryId) {
  return {
    apiKey: `demo-${industry}-key`,
    authDomain: 'prest0-demo.invalid',
    projectId: DEMO_PROJECT_ID,
    storageBucket: 'prest0-demo.invalid',
    messagingSenderId: '0',
    appId: '1:0:web:prest0demo',
  };
}

/** The visitor's account in the demo of `industry` (the workspace's Owner). */
export function demoOwnerUid(industry: DemoIndustryId): string {
  return `demo-${industry}-owner`;
}
